module.exports = __webpack_public_path__ + "img/day-pass--2x.b09c779e.jpg";